import { ApiResponse } from '@marketplace-web/core-api/api-client-util'
import { api } from '@marketplace-web/core-api/core-api-client-data'

import { UserBlockArgs } from '../types/user-block'

import {
  GetConversationPhishingPassiveReminderResp,
  UpdateConversationPhishingPassiveReminderArgs,
} from '../types/phishing-passive-reminder'

export const getConversationPhishingPassiveReminder = (id: string) =>
  api.get<GetConversationPhishingPassiveReminderResp>(`msg_threads/${id}/safety_passive_reminder`)

export const updateConversationPhishingPassiveReminder = (
  id: string,
  args: UpdateConversationPhishingPassiveReminderArgs,
) => api.post<ApiResponse>(`msg_threads/${id}/safety_passive_reminder`, args)

export const markFirstTimeListerEducationAsRead = () =>
  api.delete('conversation_safety/education/first_time_listers')

export const blockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.post(`/users/${currentUserId}/user_hates`, { hated_user_id: blockedUserId })

export const unblockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.delete(`/users/${currentUserId}/user_hates`, { params: { hated_user_id: blockedUserId } })
